package kz.dentalcrm.app.screens.appointments.add.mvi

import kotlinx.datetime.LocalDateTime
import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.PatientData
import kz.dentalcrm.app.data.network.response_model.employees.Employee

sealed interface AddAppointmentViewEvent : ViewEvent {

    data class SearchPatient(val search: String) : AddAppointmentViewEvent

    data class SelectPatient(val patient: PatientData) : AddAppointmentViewEvent

    data class TitleChanged(val value: String) : AddAppointmentViewEvent

    data class RemovePatient(val patient: PatientData) : AddAppointmentViewEvent

    data class SelectDateTime(val dateTime: LocalDateTime) : AddAppointmentViewEvent

    data class SelectEmployee(val employee: Employee) : AddAppointmentViewEvent

    data object CreateAppointment : AddAppointmentViewEvent
}